export default __webpack_public_path__ + "static/media/tete78.8768cc3a.png";